import React from 'react';
import Loader from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"

const LoadingSpinner = () => {

    return <Loader type="ThreeDots" color="#2660AD" height={100} width={100} />;
}

export default LoadingSpinner;